import React from 'react'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { Col, Container, Row } from 'react-bootstrap'
import { m } from "framer-motion"
import { changeMakersData } from './FeaturedNpoData';
import Services2 from '../../Services/Services2';

const FeaturedNpo = () => {
    return (
        <>
            <m.section className="bg-[#f7f7f7] max-sm:py-[70px] py-[70px] lg:py-[70px] md:py-[70px] sm:py-[70px] xs:py-[50px]" {...fadeIn}>
                <Container>
                    <Row className="justify-center">
                        <Col md={12} className="text-center mb-[3%]">
                            <h6 className="text-black font-extrabold max-sm:text-3xl text-4xl">Featured NPO/ Cause/ Campaign*</h6>
                        </Col>
                    </Row>
                    <Services2 grid="row-cols-1 row-cols-lg-3 row-cols-md-2 gap-y-10 justify-center" theme='service-style-02' className="" data={changeMakersData} animation={fadeIn} />
                </Container>
            </m.section>
        </>
    )
}

export default FeaturedNpo